module.exports = __webpack_public_path__ + "static/media/naoux.ece160bf.png";